import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { PopupNotification } from "../models/notifications";

@Injectable({
  providedIn: "root",
})
export class PopupNotificationService {
  private notificationSubject$ = new BehaviorSubject<PopupNotification[]>([]);
  private notifications: PopupNotification[] = [];

  addPopupNotification(notification: PopupNotification) {
    const index = this.notifications.findIndex(
      (n) => n.label === notification.label,
    );
    if (index !== -1) {
      this.notifications.splice(index, 1, notification);
    } else {
      this.notifications.push(notification);
    }
    this.updateNotificationListeners();
  }

  getPopupNotifications() {
    return this.notificationSubject$.asObservable();
  }

  getNotifications() {
    return this.notifications;
  }

  clearNotifications() {
    this.notifications = [];
    this.updateNotificationListeners();
  }

  markNotificationAsRead(notification: PopupNotification) {
    this.notifications = this.notifications.filter(
      (filteredNotification) => filteredNotification.id !== notification.id,
    );
    this.updateNotificationListeners();
  }

  markNotificationAsReadById(id: number) {
    this.notifications = this.notifications.filter(
      (filteredNotification) => filteredNotification.id !== id,
    );
    this.updateNotificationListeners();
  }

  hasUnreadPopupNotifications() {
    if (this.notifications.length === 0) {
      return false;
    }
    return this.notifications.some((notification) => !notification.isRead);
  }

  updateNotificationListeners() {
    this.notificationSubject$.next(this.notifications);
  }
}
